<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1;
    //判断是否IE浏览器
    if (
      userAgent.indexOf("compatible") > -1 &&
      userAgent.indexOf("MSIE") > -1 &&
      !isOpera
    ) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      // console.log(fIEVersion);
      if (fIEVersion <= 9) {
        alert("浏览器版本过低，请升级浏览器");
      }
      this.$router.push("/brownDownload");
      return "ie";
    }
  },
};
</script>

<style>
@import "./style/common.less";
#app {
  height: 100%;
  background-color: #f1f3f7;
}
</style>



// WEBPACK FOOTER //
// src/App.vue